<template>
  <vendor-page-template>
    <vendor-home />
  </vendor-page-template>
</template>

<script>
// import vendorSignupBanner from '@/components/widgets/vendor/vendorSignupBanner'
// import vendorLoginForm from '@/components/shared/forms/VendorLogin'
import VendorHome from '@/components/pages/vendor/VendorHome'
import VendorPageTemplate from '@/components/pages/vendor/VendorPageTemplate'
import { mapActions, mapGetters } from 'vuex'

export default {
	components: {
		// vendorSignupBanner,
		// vendorLoginForm,
		VendorHome,
		VendorPageTemplate
	},
	computed: {
		...mapGetters('vendor', ['isVendorAuthenticated'])
	},
	methods: {
		...mapActions('vendor', ['setVendorAuthenticated']),
		setAuth () {
			if (this.isVendorAuthenticated === true) {
				this.setVendorAuthenticated(false)
			}
		},
		loginmodal () {

		}
	},
	mounted () {
		this.setAuth()
	}
}
</script>

<style scoped>
</style>
